import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-how-to-install-page',
  templateUrl: './how-to-install-page.component.html',
  styleUrls: [ './how-to-install-page.component.scss' ]
})
export class HowToInstallPageComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
